import logo from "../assets/logo.jpeg";
import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { LayoutDashboard, Receipt, Settings, BarChart3, LogOut, Menu, UserCircle   } from "lucide-react";

const navItems = [
  { to: "/dashboard", label: "Dashboard", Icon: LayoutDashboard },
  { to: "/billing",   label: "Billing",   Icon: Receipt },
  { to: "/reports",   label: "Reports",   Icon: BarChart3 },
  {to: "/contact",     label: "Contact",  Icon: UserCircle },
  { to: "/settings",  label: "Settings",  Icon: Settings },
];

const Sidebar = ({ onClose }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate("/"); };

  return (
    <aside className="flex h-full w-64 flex-col bg-gray-900 text-gray-100">
      <div className="flex items-center gap-3 border-b border-gray-700 px-5 py-5">
  <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-white overflow-hidden">
    <img src={logo} alt="logo" className="h-full w-full object-cover" />
   </div>
   <div>
    <h1 className="font-display text-lg font-bold text-white">Kids Fun Factory</h1>
    <p className="text-xs text-gray-400">Admin Panel</p>
  </div>
   </div>
      <nav className="flex-1 space-y-1 px-3 py-4">
        {navItems.map(({ to, label, Icon }) => (
          <NavLink key={to} to={to} onClick={onClose}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${
                isActive ? "bg-gray-800 text-purple-400" : "text-gray-400 hover:bg-gray-800 hover:text-gray-100"
              }`
            }
          >
            <Icon size={17} />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-gray-700 p-3">
        <button onClick={handleLogout}
          className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-400 hover:bg-gray-800 hover:text-red-400 transition-colors">
          <LogOut size={16} /> Logout
        </button>
      </div>
    </aside>
  );
};

export default function AdminLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Desktop sidebar */}
      <div className="hidden md:fixed md:inset-y-0 md:flex md:w-64 z-30">
        <Sidebar />
      </div>
      {/* Mobile overlay */}
      {open && (
        <div className="fixed inset-0 z-40 flex md:hidden">
          <div className="fixed inset-0 bg-black/50" onClick={() => setOpen(false)} />
          <div className="relative z-50"><Sidebar onClose={() => setOpen(false)} /></div>
        </div>
      )}
      <div className="flex flex-1 flex-col md:pl-64">
        <div className="flex items-center gap-3 border-b border-gray-200 bg-white px-4 py-3 md:hidden">
          <button onClick={() => setOpen(true)} className="rounded-lg p-1.5 text-gray-600 hover:bg-gray-100">
            <Menu size={20} />
          </button>
          <span className="font-bold text-gray-900">Fun City Admin</span>
        </div>
        <main className="flex-1 p-4 md:p-6"><Outlet /></main>
      </div>
    </div>
  );
}